<template>
  <v-app>
    <router-view />
    <v-snackbar
      v-for="(snackbar, index) in allSnakbars.filter(s => s.showing)"
      :key="snackbar.text + Math.random()"
      v-model="snackbar.showing"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :style="`padding-bottom: ${(index * 70) + 8}px`"
    >
    <span style="color:black"> {{snackbar.text}} </span>
      <v-btn text @click="snackbar.showing = false">
        <v-icon dark>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "App",
  components: {},
  data: () => ({}),
  methods: {},
  watch: {},
  mounted(){
    console.log(this.$store)
  },
  computed:mapGetters(['allSnakbars']),
};
</script>
<style>
body{
  background-color: #E8E8E8;
}
@media print {
  
  body {
    height: 100%;
    width: 100%;
  }
  .no-display {
    display: none !important;
  }
  
}
</style>
